import sessionTypes from 'helpers/enums/sessionTypes'

const sessionTypesWithSubmitDisabled = [
	sessionTypes.TEACHER_STUDENT_VIEW,
]

const sessionTypesWithNoSubmit = [
	sessionTypes.EMBED,
	sessionTypes.PREVIEW,
]

export {
	sessionTypesWithSubmitDisabled,
	sessionTypesWithNoSubmit,
}
